import Api from "../api";
const basePath = "/User";
export function getAll(params) {
    return Api.post(`${basePath}/getAllUserPicker`, params);
}
export async function importFromFile(file, reimport) {
    const formData = new FormData();
    formData.append("file", file);
    try {
        const res = await Api.post(`${basePath}/import-from-file?reimport=` + reimport, formData);
        return [res, undefined];
    }
    catch (err) {
        if (err.response) {
            const errHelper = err;
            return [undefined, errHelper.response?.data];
        }
        throw err;
    }
}
